import React from 'react';

const ContactUs = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">Contact Us</h1>
    <p className="mb-6">
      Have questions about our quantum security solutions? Our team is ready to help you protect your organization against quantum threats.
    </p>
    
    <div className="bg-white shadow-md rounded-lg p-6 mb-6">
      <h2 className="text-xl font-semibold mb-4">Get in Touch</h2>
      <p className="mb-4">
        You can reach our quantum security experts via email. We'll respond to your inquiry within 24 hours.
      </p>
      <a 
        href="mailto:contact@quantumsafeaudit.com"
        className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition duration-300"
      >
        Send us an Email
      </a>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-gray-100 p-4 rounded-md">
        <h2 className="text-xl font-semibold mb-2">Business Inquiries</h2>
        <p>
          For business partnerships and enterprise solutions, please contact our business development team.
        </p>
      </div>
      <div className="bg-gray-100 p-4 rounded-md">
        <h2 className="text-xl font-semibold mb-2">Support</h2>
        <p>
          Need technical assistance with our products? Our support team is here to help.
        </p>
      </div>
    </div>
  </div>
);

export default ContactUs;